import React from 'react';
import { Helmet } from 'react-helmet';

export const MetaDefaults: React.FC = () => (
  <Helmet defaultTitle="Envative" titleTemplate="%s - Envative">
    <title>Envative</title>
    <meta name="description" content="Custom web, mobile, and IoT development" />
  </Helmet>
);
